import styles from "./ImpersonationLogin.module.scss";
import { DefaultButton } from "../../../common/components/button/defaultButton/DefaultButton";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../common/infrastructure/components/RenderWhen";
import { useImpersonationLogin } from "./hooks/useImpersonationLogin";

export const ImpersonationLogin = () => {
  const { errorMessage, goToStart } = useImpersonationLogin();

  return (
    <div className={styles.root}>
      <div className={styles.root_panel}>
        <RenderWhen condition={!!errorMessage}>
          <IfTrue>
            <h2 className={styles.root_panel_title}>Входът не беше успешен</h2>
            <p className={styles.root_panel_text}>{errorMessage}</p>
            <DefaultButton label="Към началото" onClick={goToStart} width="100%" />
          </IfTrue>
          <IfFalse>
            <h2 className={styles.root_panel_title}>Влизане в профила…</h2>
            <p className={styles.root_panel_text}>Отваряме профила на потребителя.</p>
          </IfFalse>
        </RenderWhen>
      </div>
    </div>
  );
};
